export const environment = {
  production: true,
  GRAPHQL_URL: 'https://staging-radar-api.voyagu.app/portal/graphql',
  GRAPHQL_PROTECTED_URL: 'https://staging-radar-api.voyagu.app/a-portal/graphql',
  GRAPHQL_SCHEMA_URL: 'https://staging-radar-api.voyagu.app/portal/schema',
  BUILD_QUERY_KEY: '6a004d54ad43#14',
  STRIPE_PUBLIC_KEY: 'pk_test_51Qi5EFCH65qHeuOepw78FZt7hZsnhFMqaUIYx6DxSoIYHdBFXu2Bu1NLaJuYbGRFqoG5OBn99Yd4IdoWIsQpFUHR00SJreogAG',
  CLOUDFRONT_API: 'https://d3oa8725zk6wjh.cloudfront.net/staging/portal/graphql',
  TRACKING_URL: 'https://staging-tr.businessclassconsolidator.com',
  AWS_PROJECT_REGION: 'eu-west-1',
  AWS_COGNITO_REGION: 'eu-west-1',
  AWS_USER_POOLS_ID: 'eu-west-1_7vq5burya',
  AWS_USER_POOLS_WEB_CLIENT_ID: '5qkbq33e6o7v0u9q1ocdlubv3a',
  OAUTH_DOMAIN: 'staging-portal.auth.eu-west-1.amazoncognito.com',
  AMPLIFY_REDIRECT_SIGN_IN: 'https://staging-q.bcconsolidator.com/login',
  AMPLIFY_REDIRECT_SIGN_OUT: 'https://staging-q.bcconsolidator.com/logout',
  GOOGLE_FLIGHTS_URL: 'https://es4ky7tw7mm7e6plmyor2vbm6m0ghkne.lambda-url.eu-west-1.on.aws/api/google_flights/search',
};